import React from 'react';
import moment from 'moment';
import {
  object, number,
} from 'yup';

import FormResource from './FormResource.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';
import FieldPlayersList from './FieldPlayersList.jsx';

const defaults = {
  name: '',
  date: {
    date: '',
    time: '',
  },
  location: '',
  distance: 1000,
  traction: 'dry',
  level: 0,
  status: 'P',
  type: 'N',
  entryFee: 0,
  prizePool: 0,
  players: [],
  winner: [],
  startAt: {
    date: moment().format('YYYY-MM-DD'),
    time: '00:00',
  },
  endAt: {
    date: '',
    time: '',
  },
  // address: '',
  image: '',
  gameUrl: '',
};

const FormRace = ({
  race,
}) => (
  <FormResource
    {...{
      defaults,
      schema: object({
        distance: number().max(3000).min(0).required(),
        level: number().max(6).min(0).required(),
        entryFee: number().min(0),
        prizePool: number().min(0),
      }),
      stored: race ? {
        ...race,
        date: {
          date: moment(race.date).format('YYYY-MM-DD'),
          time: moment(race.date).format('HH:mm'),
        },
        startAt: {
          date: moment(race.startAt).format('YYYY-MM-DD'),
          time: moment(race.startAt).format('HH:mm'),
        },
        endAt: {
          date: moment(race.endAt).format('YYYY-MM-DD'),
          time: moment(race.endAt).format('HH:mm'),
        },
      } : undefined,
      api: '/api/site/races',
      options: {omitIds: false},
      onSubmit: (v) => ({
        ...v,
        date: moment(
          `${v.date.date} ${v.date.time}`,
          'YYYY-MM-DD HH:mm',
        ).toDate(),
        startAt: moment(
          `${v.startAt.date} ${v.startAt.time}`,
          'YYYY-MM-DD HH:mm',
        ).toDate(),
        endAt: moment(
          `${v.endAt.date} ${v.endAt.time}`,
          'YYYY-MM-DD HH:mm',
        ).toDate(),
      }),
    }}
  >
    <div className="row">
      <div className="col">
        <FormGroup name="name" label="Name"/>
      </div>
      <div className="col">
        <div className="form-row">
          <div className="col">
            <FormGroup
              name="date.date"
              type="date"
              label="Date"
            />
          </div>
          <div className="col">
            <FormGroup name="date.time" type="time" label="Time" />
          </div>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col col-6">
        <FormGroup name="address" label="Address"/>
      </div>
      <div className="col">
        <FormGroup name="entryFee" label="Entry Fee"/>
      </div>
      <div className="col">
        <FormGroup name="prizePool" label="Prize Pool"/>
      </div>
    </div>
    <div className="row">
    <div className="col">
        <FormGroup name="location" label="Location"/>
      </div>
      <div className="col">
        <FormGroup name="distance" label="Distance"/>
      </div>
      <div className="col">
        <FormGroup name="traction" label="Traction"/>
      </div>
    </div>
    <div className="row">
      <div className="col">
        <FormGroup name="level" label="Level"/>
      </div>
      <div className="col">
        <FormGroup name="status" label="Status"/>
      </div>
    </div>
    <div className="row">
      <div className="col">
        <div className="form-row">
          <div className="col">
            <FormGroup
              name="startAt.date"
              type="date"
              label="Start Date"
            />
          </div>
          <div className="col">
            <FormGroup name="startAt.time" type="time" label="Time" />
          </div>
          <div className="col">
            <FormGroup
              name="endAt.date"
              type="date"
              label="End Date"
            />
          </div>
          <div className="col">
            <FormGroup name="endAt.time" type="time" label="Time" />
          </div>
        </div>
      </div>
    </div>

    <FormGroup name="gameUrl" label="Game URL"/>

    <div className="form-group">
      <label>Players</label>
      <FieldPlayersList/>
    </div>

    <FormGroup
        name="image"
        label="Image"
        as="coverImg"
        api="/api/site/banners/files"
    />

  </FormResource>
);

export default FormRace;
